import { useEffect } from "react";

/** Mídia em tela cheia / editor: pinch com 2 dedos (não bloquear). */
const isInsideAllowPinchZoom = (target: EventTarget | null) =>
  target instanceof Element && target.closest("[data-allow-pinch-zoom]") !== null;

export const usePreventZoom = () => {
  useEffect(() => {
    const preventZoom = (e: Event) => {
      if (isInsideAllowPinchZoom(e.target)) return;
      e.preventDefault();
    };

    const preventPinchZoom = (e: TouchEvent) => {
      if (isInsideAllowPinchZoom(e.target)) return;
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    const preventWheelZoom = (e: WheelEvent) => {
      if (isInsideAllowPinchZoom(e.target)) return;
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    // Bloquear zoom com Ctrl+Wheel ou Cmd+Wheel
    document.addEventListener("wheel", preventWheelZoom, { passive: false });

    // Bloquear pinch zoom em dispositivos touch (exceto visualizadores de mídia)
    document.addEventListener("touchstart", preventPinchZoom, { passive: false });
    document.addEventListener("touchmove", preventPinchZoom, { passive: false });

    // Safari: gestos de pinça na página (permitir dentro de data-allow-pinch-zoom)
    document.addEventListener("gesturestart", preventZoom, { passive: false });
    document.addEventListener("gesturechange", preventZoom, { passive: false });
    document.addEventListener("gestureend", preventZoom, { passive: false });

    return () => {
      document.removeEventListener("wheel", preventWheelZoom);
      document.removeEventListener("touchstart", preventPinchZoom);
      document.removeEventListener("touchmove", preventPinchZoom);
      document.removeEventListener("gesturestart", preventZoom);
      document.removeEventListener("gesturechange", preventZoom);
      document.removeEventListener("gestureend", preventZoom);
    };
  }, []);
};